export type Resource = {
  label: string
  title: string
  description: string
  cover: string
}

export const resources: Resource[] = [
  {
    label: 'Guía principal',
    title: 'Europa por Primera Vez',
    description:
      'Todo el proceso de planificación explicado paso a paso: presupuesto, vuelos, alojamiento, transporte, rutas, entradas, dinero, documentación y preparación.',
    cover: 'https://cdn.magicpatterns.com/uploads/pDACVAmWpVxPzdzBJsBmpw/EUROPA_POR_PRIMERA_VEZ.png',
  },
  {
    label: 'Rutas recomendadas',
    title: '19 rutas listas para adaptar',
    description:
      'Itinerarios pensados para viajes de 7, 10, 15, 20 y 30 días, además de alternativas según diferentes estilos de viajero.',
    cover: 'https://cdn.magicpatterns.com/uploads/jcsbsTPVsBppeWjEC7SSUy/rutas_recomendadas.png',
  },
  {
    label: 'Planner de viaje editable',
    title: 'Todo tu viaje organizado',
    description:
      'Centralizá vuelos, alojamientos, transportes, actividades, itinerario, documentación y pendientes.',
    cover: 'https://cdn.magicpatterns.com/uploads/sLEukxdt7EngCuwvDmBu4Q/Planner_de_Viaje_editable.png',
  },
  {
    label: 'Plantilla de presupuesto',
    title: 'Controlá tus gastos',
    description:
      'Planificá cuánto querés gastar, registrá tus gastos y compará presupuesto estimado vs. real.',
    cover: 'https://cdn.magicpatterns.com/uploads/hcAA43t9Q6JW9UMtVPuGiu/Plantilla_de_presupuesto.png',
  },
  {
    label: 'Checklist pre-viaje',
    title: 'Sabé qué resolver y cuándo',
    description: 'Organizado desde 6 meses antes del viaje hasta el mismo día de salir.',
    cover: 'https://cdn.magicpatterns.com/uploads/do4fyrdcnNJxxbXSPuh4tM/Checklist.png',
  },
  {
    label: 'Apps útiles para Europa',
    title: 'Tus herramientas durante el viaje',
    description:
      'Mapas, transporte, vuelos, alojamiento, dinero, traducción, entradas y documentación.',
    cover: 'https://cdn.magicpatterns.com/uploads/tcrgqZVTJfMqSgQsnVTJio/apps_utiles_europa.png',
  },
  {
    label: 'Errores caros a evitar',
    title: 'Decisiones que conviene pensar dos veces',
    description:
      'Los errores más frecuentes del primer viaje y cómo evitar que terminen costándote de más.',
    cover: 'https://cdn.magicpatterns.com/uploads/b7NAPsiNxk4X8RYLad5tL2/errores_caros.png',
  },
  {
    label: 'Equipaje inteligente',
    title: 'Viajá con lo que realmente necesitás',
    description:
      'Una guía práctica para preparar una valija adaptada a trenes, low cost, escaleras y cambios de ciudad.',
    cover: 'https://cdn.magicpatterns.com/uploads/qtHkvCBoW8csLh6EHGxHfT/equipaje_inteligente.png',
  },
]
